import React from 'react';
// Unused imports removed
import './HeroSection.css';
import heroBg from '../assets/FeedTheNeedy.jpeg';

const stats = [
    {
        icon: (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="url(#grad)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                <defs><linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#3b82f6" /><stop offset="100%" stopColor="#06b6d4" /></linearGradient></defs>
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
        ),
        number: '500+',
        label: 'Volunteers',
    },
    {
        icon: (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="url(#grad2)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                <defs><linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#3b82f6" /><stop offset="100%" stopColor="#06b6d4" /></linearGradient></defs>
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
            </svg>
        ),
        number: '20+',
        label: 'Communities Served',
    },
    {
        icon: (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="url(#grad3)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <defs>
                    <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#3b82f6" />
                        <stop offset="100%" stopColor="#06b6d4" />
                    </linearGradient>
                </defs>

                {/* Complete Fork: 2 outer prongs with curved base, 1 center prong, and handle */}
                <path d="M3 2v7a3 3 0 0 0 6 0V2 M6 12V2 M6 12v10" fill="rgba(6, 182, 212, 0.05)" />

                {/* Upright Knife */}
                <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" fill="rgba(59, 130, 246, 0.05)" />
            </svg>
        ),
        number: '10K+',
        label: 'Meals Served',

    },
    {
        icon: (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="url(#grad4)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                <defs><linearGradient id="grad4" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#3b82f6" /><stop offset="100%" stopColor="#06b6d4" /></linearGradient></defs>
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
        ),
        number: '5+',
        label: 'Active Projects',
    },
];

const HeroSection = () => {
    return (
        <>
            <section className="hero-section">
                <div className="hero-bg-media" style={{ backgroundImage: `url(${heroBg})` }}></div>
                <div className="hero-overlay"></div>
                <div className="container hero-content-container">
                    <div className="hero-content">
                        <h1 className="animate-fade-up">Empowering Volunteers, <br />Enriching Communities</h1>
                        <p className="animate-fade-up delay-1">Join Being Volunteer USA and make a difference. Find meaningful volunteer opportunities and connect with organizations in need.</p>
                        <div className="hero-actions animate-fade-up delay-2">
                             <a href="/#projects" className="cta-button primary" onClick={(e) => {
                                e.preventDefault();
                                const el = document.getElementById('projects');
                                if (el) el.scrollIntoView({ behavior: 'smooth' });
                            }}>
                                <span>Find Volunteer Opportunities</span>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                    <polyline points="12 5 19 12 12 19"></polyline>
                                </svg>
                            </a>
                            <a 
                                href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=GMVXR9RS2FD84" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="cta-button secondary"
                            >
                                <span>Donate</span>
                                <svg className="heart-icon" width="22" height="22" viewBox="0 0 24 24" fill="url(#heartGrad)" stroke="#9f1239" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <defs>
                                        <linearGradient id="heartGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                            <stop offset="0%" stopColor="#e11d48" stopOpacity="0.95" />
                                            <stop offset="100%" stopColor="#4c0519" stopOpacity="0.6" />
                                        </linearGradient>
                                    </defs>
                                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* 📊 Impact Stats Ribbon — overlaps bottom of hero */}
            <div className="impact-stats">
                {stats.map((stat) => (
                    <div className="impact-stat-item" key={stat.label}>
                        <span className="impact-stat-icon">{stat.icon}</span>
                        <span className="impact-stat-number">{stat.number}</span>
                        <span className="impact-stat-label">{stat.label}</span>
                    </div>
                ))}
            </div>
        </>
    );
};

export default HeroSection;
